import { Theme } from '@mui/material'

const useStyles = {
  searchBarContainer: { width: '100%', maxWidth: '866px' },
  searchResultContainer: (theme: Theme) => ({
    padding: theme.spacing(0, 3, 0, 3),
  }),
  searchTab: {
    minHeight: '50px',
  },
  resultsContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.action.hover,
    marginLeft: theme.spacing(-1),
    padding: theme.spacing(2, 0),
    height: '100%',
  }),
  resultItemContainer: (theme: Theme) => ({
    padding: theme.spacing(0, 2),
  }),
  resultItem: (theme: Theme) => ({
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 1, 2, 1),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  }),
  resultItemLink: (theme: Theme) => ({
    margin: theme.spacing(0.5, 0),
  }),
  resultItemContact: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    display: 'inline-flex',
    alignItems: 'center',
    margin: theme.spacing(0.5, 2, 0, 0),
  }),
  resultItemAddress: {
    textTransform: 'capitalize',
  },
  resultItemContactIcon: {
    fontSize: '16px',
    color: 'inherit',
    marginRight: '3px',
  },
  filterContainerGridItem: (theme: Theme) => ({
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(-1),
      marginTop: theme.spacing(2),
    },
  }),
  filterContainer: (theme: Theme) => ({
    border: `1px solid ${theme.palette.action.selected}`,
    padding: theme.spacing(2, 3, 3, 3),
    borderRadius: theme.spacing(1),
  }),
}
export default useStyles
